import SettingsLayout, {
  GlobalItemRoute,
  LEGACY_REDIRECTS,
  LegacyRedirect,
} from '@portal/containers/settings/SettingsLayout';
import { GLOBAL_PAGES, OVERVIEW_PAGE } from '@portal/containers/settings/SettingsTabs';
import { Route, Routes } from 'react-router-dom';
import { PortalPath } from './constants';
import EamcLayout, {
  EAMC_LEGACY_REDIRECTS,
  EAMC_PAGES,
  EamcItemRoute,
  EamcRedirect,
} from './containers/eamc/EamcLayout';
import EntraIdSuccess from './containers/entraId/EntraIdSuccess';
import { PortalLanding } from './containers/landing/PortalLanding';
import Settings from './containers/settings/Settings';
import { MfaRestrictedRoute } from './MfaRestrictedRoute';
import Portal from './index';

const PortalRoutes = () => {
  return (
    <Routes>
      <Route path={'/'} element={<Portal />}>
        <Route index element={<PortalLanding />} />
        <Route
          path={'/entraid/auth-success'}
          element={
            <MfaRestrictedRoute>
              <EntraIdSuccess />
            </MfaRestrictedRoute>
          }
        />
        <Route
          path={PortalPath.SETTINGS}
          element={
            <MfaRestrictedRoute>
              <SettingsLayout />
            </MfaRestrictedRoute>
          }
        >
          <Route index element={<Settings item={OVERVIEW_PAGE} />} />
          {GLOBAL_PAGES.map(item => (
            <Route
              key={item.key}
              path={item.routes.global}
              element={<GlobalItemRoute item={item} />}
            />
          ))}
          {LEGACY_REDIRECTS.map(row => (
            <Route key={row.from} path={row.from} element={<LegacyRedirect {...row} />} />
          ))}
        </Route>
        <Route
          path={PortalPath.EAMC}
          element={
            <MfaRestrictedRoute>
              <EamcLayout />
            </MfaRestrictedRoute>
          }
        >
          <Route index element={<EamcRedirect />} />
          {EAMC_PAGES.map(item => (
            <Route key={item.key} path={item.routes.eamc} element={<EamcItemRoute item={item} />} />
          ))}
          {EAMC_LEGACY_REDIRECTS.map(row => (
            <Route key={row.from} path={row.from} element={<LegacyRedirect {...row} />} />
          ))}
          <Route path="*" element={<EamcRedirect />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default PortalRoutes;
